import { render, staticRenderFns } from "./FormCreateUser.vue?vue&type=template&id=6ce8f54a&"
import script from "./FormCreateUser.vue?vue&type=script&lang=js&"
export * from "./FormCreateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports